import React, { useEffect, useState } from "react";
import SliderAuth from "../../../components/SliderAuth/SliderAuth";
import { images } from "../../../config/images";
import { Grid, FormControl, OutlinedInput, InputAdornment, } from "@mui/material";
import { Button } from "../../../components/Button/button"
import { useNavigate, Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast } from "react-toastify";
import { updatePassword } from "../../../config/services";
import translations from "../../../config/language";
import { notifyError, notifySuccess } from "../../../config/ToastMessage";

const CreatePassword = ({ mobileNo, onCancelClick, }) => {
    const navigate = useNavigate();

    const [formvalues, setFormvalue] = useState({
        newPassword: "",
        confirmPassword: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showconfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        setFormvalue({ ...formvalues, [e.target.name]: e.target.value });
    };

    const [lengthValid, setLengthValid] = useState(false);
    const [numberValid, setNumberValid] = useState(false);
    const [specialCharValid, setSpecialCharValid] = useState(false);
    const [lowercaseValid, setLowercaseValid] = useState(false);
    const [uppercaseValid, setUppercaseValid] = useState(false);
    useEffect(() => {
        // Check password length

        if (
            formvalues.newPassword.length >= 8 &&
            formvalues.newPassword.length <= 16
        ) {
            setLengthValid(true);
        } else {
            setLengthValid(false);
        }

        // Check for number
        const numberRegex = /\d/;
        if (numberRegex.test(formvalues.newPassword)) {
            setNumberValid(true);
        } else {
            setNumberValid(false);
        }

        // Check for special character
        const specialCharRegex = /[^\w\s]/;
        if (specialCharRegex.test(formvalues.newPassword)) {
            setSpecialCharValid(true);
        } else {
            setSpecialCharValid(false);
        }

        // Check for lowercase letter
        const lowercaseRegex = /[a-z]/;
        if (lowercaseRegex.test(formvalues.newPassword)) {
            setLowercaseValid(true);
        } else {
            setLowercaseValid(false);
        }

        // Check for uppercase letter
        const uppercaseRegex = /[A-Z]/;
        if (uppercaseRegex.test(formvalues.newPassword)) {
            setUppercaseValid(true);
        } else {
            setUppercaseValid(false);
        }

    }, [formvalues.newPassword]);


    const handleSubmit = async () => {
        if (!formvalues.newPassword) {
            notifyError("Please enter password in both field.");
            return true;
        }
        if (!formvalues.confirmPassword) {
            notifyError("Please enter password in both field.");
            return true;
        }
        if (
            !lengthValid ||
            !numberValid ||
            !specialCharValid ||
            !lowercaseValid ||
            !uppercaseValid
        ) {
            return true;
        }

        if (formvalues.newPassword != formvalues.confirmPassword) {
            notifyError("Please check password is not same.");
            return true;
        }

        const params = {
            mobile_number: `91${mobileNo}`,
            password: formvalues.newPassword
        }

        try {
            const resp = await updatePassword(params);

            if (resp.data.success == true) {
                notifySuccess(resp.data.message)
                navigate("/");
            }
        }
        catch (error) {
            console.log(error);
            notifyError(error.response.data.message);
        }
    };

    const handleTogglePasswordVisibility = (name) => {
        if (name === "newPassword") {
            setShowPassword((prevShowPassword) => !prevShowPassword);
        } else if (name === "confirmPassword") {
            setShowConfirmPassword((prevShowConfirmPassword) => !prevShowConfirmPassword);
        }
    };

    const language = process.env.REACT_APP_LANGUAGE;

    return (
        <>
            <div></div>
            <Grid container className="main-container">
                <SliderAuth />
                <Grid item xs={12} md={5} lg={4} className="signIn-form-wrap">
                    <div className="logo-div">
                        <Link to="#" onClick={() => onCancelClick()}
                            className="page-back-btn"> {/* navigate to back screen */}
                            <ArrowBackIcon className="back-arrow-icon" />
                        </Link>
                        <div className="pb-2">
                            <img src={images.twoStepLogo} alt="Sign Up" className="signIn-logo" />
                        </div>
                    </div>
                    <h3 className="text-center singIn-title">{translations[language].createPassword}</h3>

                    {/* Sing up Form  */}

                    <div className="signUp-form">

                        <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showPassword ? 'text' : 'password'}
                                value={formvalues.newPassword}
                                onChange={handleChange}
                                name="newPassword"
                                startAdornment={
                                    <InputAdornment position="start">
                                        <img
                                            src={images.viewPassword}
                                            // onClick={() => handleTogglePasswordVisibility("newPassword")}
                                            className="input-logo"
                                        >
                                        </img>
                                    </InputAdornment>
                                }
                                endAdornment={
                                    <InputAdornment position="start">
                                        <img
                                            src={images.viewIcon}
                                            onClick={() => handleTogglePasswordVisibility("newPassword")}
                                            className="input-logo"
                                            style={{ cursor: "pointer" }}
                                        >
                                        </img>
                                    </InputAdornment>
                                }
                                placeholder={translations[language].enterPassword}
                            />
                        </FormControl>
                        <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
                            <OutlinedInput
                                id="outlined-adornment-password"
                                type={showconfirmPassword ? 'text' : 'password'}
                                value={formvalues.confirmPassword}
                                onChange={handleChange}
                                name="confirmPassword"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleSubmit();
                                    }
                                }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <img
                                            src={images.viewPassword}
                                            // onClick={() => handleTogglePasswordVisibility("confirmPassword")}
                                            className="input-logo"
                                        >
                                        </img>
                                    </InputAdornment>
                                }
                                endAdornment={
                                    <InputAdornment position="start">
                                        <img
                                            src={images.viewIcon}
                                            onClick={() => handleTogglePasswordVisibility("confirmPassword")}
                                            className="input-logo"
                                            style={{ cursor: "pointer" }}
                                        >
                                        </img>
                                    </InputAdornment>
                                }
                                placeholder={translations[language].rePassword}
                            />
                        </FormControl>

                        <div className="reEnterPassword-TextWrap">
                            <h6>
                                <b>{translations[language].passwordValidation}</b>
                            </h6>
                            <Grid container spacing={3}>
                                <Grid item xs={6}>
                                    <h6
                                        style={{
                                            color: formvalues.newPassword
                                                ? lengthValid
                                                    ? "green"
                                                    : "red"
                                                : "",
                                        }}
                                    >
                                        {translations[language].includesCharacters}
                                    </h6>
                                    <h6
                                        style={{
                                            color: formvalues.newPassword
                                                ? numberValid
                                                    ? "green"
                                                    : "red"
                                                : "",
                                        }}
                                    >
                                        {translations[language].includesNumber}
                                    </h6>
                                    <h6
                                        style={{
                                            color: formvalues.newPassword
                                                ? specialCharValid
                                                    ? "green"
                                                    : "red"
                                                : "",
                                        }}
                                    >
                                        {translations[language].includesSpecialChar}
                                    </h6>
                                </Grid>
                                <Grid item xs={6}>
                                    <h6
                                        style={{
                                            color: formvalues.newPassword
                                                ? lowercaseValid
                                                    ? "green"
                                                    : "red"
                                                : "",
                                        }}
                                    >
                                        {translations[language].includesLowercase}
                                    </h6>
                                    <h6
                                        style={{
                                            color: formvalues.newPassword
                                                ? uppercaseValid
                                                    ? "green"
                                                    : "red"
                                                : "",
                                        }}
                                    >
                                        {translations[language].includesUppercase}
                                    </h6>
                                </Grid>
                            </Grid>
                        </div>

                    </div>
                    <div style={{ marginTop: "2rem", width: "100%", padding: "20px 0" }}>
                        <Button
                            title={translations[language].createPassword}
                            classname={"custom-button"}
                            onClick={handleSubmit}
                        />
                    </div>
                </Grid>
            </Grid>
        </>
    )
}
export default CreatePassword;